export enum PaymentMethodType {
  CARD = 'CARD',
  GLOBAL_CARD = 'GLOBAL_CARD',
  BOOT_PAY = 'BOOT_PAY',
}